import React, { useState } from "react";
import Field from "../../../../formComponents/formFields/field.component";
import get from "lodash/get";
import { useFormContext } from "react-hook-form";
import {
  StyledDeliverableSubmissionField,
  StyledControls,
} from "./deliverableSubmissionFields.style";

const DeliverableSubmissionField = ({
  settings = {},
  index,
  parentName,
  values = {},
  append,
  lastVisibleIndex,
}) => {
  const {
    register,
    formState: { errors },
    setValue,
  } = useFormContext();
  const { id, _destroy, ...fields } = settings;
  const fieldArray = Object.values(fields);

  const [hidden, setHidden] = useState(false);

  const handleRemove = (e) => {
    e.preventDefault();
    setValue(`${parentName}.${index}.${_destroy.name}`, true);
    setHidden(true);
  };

  const handleAddField = (e) => {
    e.preventDefault();
    append({
      _destroy: _destroy.default,
      title: fields.title.default,
      required: fields.required.default,
    });
  };

  const isLastVisibleIndex = lastVisibleIndex === index;
  return (
    <StyledDeliverableSubmissionField $hidden={hidden ? 1 : 0}>
      {values.id && (
        <input
          type="hidden"
          {...register(`${parentName}.${index}.${id.name}`)}
        />
      )}
      <input
        type="hidden"
        {...register(`${parentName}.${index}.${_destroy.name}`, {
          value: values._destroy || _destroy.default,
        })}
      />
      {fieldArray.map((item, idx) => (
        <Field
          key={idx}
          {...item}
          value={get(values, item.name) || item.default}
          name={`${parentName}.${index}.${item.name}`}
          error={get(errors, `${parentName}.${index}.${item.name}`)}
        />
      ))}

      <StyledControls>
        <a href="#" onClick={handleRemove}>
          – Remove deliverable
        </a>
        {isLastVisibleIndex && (
          <a href="#" onClick={handleAddField}>
            + Add another deliverable
          </a>
        )}
      </StyledControls>
      {!isLastVisibleIndex && <hr />}
    </StyledDeliverableSubmissionField>
  );
};

export default DeliverableSubmissionField;
